// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { TypographyProps } from "@insite/mobius/Typography";
import { productBrandStyles } from "@tps/Overrides/Components/ProductBrand";
import { css } from "styled-components";

const nameText: TypographyProps = {
    lineHeight: "19px",
    css: css`
        width: auto;
        ${wrapInContainerStyles}
    `,
    size: "14px",
    weight: 700,
};

productBrandStyles.nameText = { ...nameText };
productBrandStyles.nameLink = {
    css: css`
        width: auto;
    `,
    typographyProps: nameText,
};

productBrandStyles.wrapper = {
    css: css`
        width: 100%;
    `,
};
